import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { SERVER_API } from '../../constants'

const getTopSimilarAdVideos = createAsyncThunk('landing/similar', async ({ videoUrl }) => {
  return axios.post(`${SERVER_API.BASE_URL}/top-similar`, { video_url: videoUrl }, {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    withCredentials: true
  })
    .then(response => {
      return { data: response.data };
    })
    .catch(error => {
      if (error.response.data) {
        return { error: error.response.data };
      } else {
        return { error };
      }
    });
});

export { getTopSimilarAdVideos };
